import styled from 'styled-components';

export const StyledPriceSpinnerWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StyledSpinnerContainer = styled('div')`
  display: flex;
  align-items: center;
`;

export const StyledDigitContainer = styled('div')<{ $digit: string }>`
  overflow: hidden;
  height: 1em;
  position: relative;
  width: ${(props) => (props.$digit === '' ? '0' : '1ch')};
  opacity: ${(props) => (props.$digit === '' ? 0 : 1)};
  text-align: center;
  transition:
    width 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.3),
    opacity 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.3);
  -webkit-mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    black 20%,
    black 80%,
    transparent 100%
  );
`;

export const StyledDigitInner = styled('div')<{ $digit: string }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  transform: ${(props) =>
    props.$digit === '' ? 'translateY(0)' : `translateY(-${props.$digit}em)`};
  transition: transform 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.1);
`;

export const StyledNumber = styled('div')`
  height: 1em;
  line-height: 1em;
`;
